import React, { forwardRef } from 'react'
import styled from 'styled-components'
import cx from 'classnames'
import { IconName, svgIcons } from './iconDef'
import { FeedbotSuspense } from '../FeedbotSuspense'

export interface SvgIconProp {
  name: IconName
  primaryColor?: string
  secondaryColor?: string
  width?: number
  height?: number
  className?: string
  dataTest?: string
  onClick?(): void
}

export interface WrapperProp {
  $primaryColor?: string
  $secondaryColor?: string
  $width?: number
  $height?: number
}

export const SvgIcon: React.FC<SvgIconProp> = forwardRef((props, ref) => {
  const {
    name,
    primaryColor,
    secondaryColor,
    width,
    height,
    className,
    dataTest,
    onClick,
    ...rest // mui tooltip handlers
  } = props

  const IconSvgComponent = svgIcons[name]
  return (
    <Wrapper
      className={cx('svgIcon', className)}
      data-test={dataTest}
      onClick={onClick}
      $primaryColor={primaryColor}
      $secondaryColor={secondaryColor}
      $width={width}
      $height={height}
      {...rest}
      ref={ref as any}
    >
      <IconSvgComponent />
    </Wrapper>
  )
})

const Wrapper = styled.div<WrapperProp>`
  display: flex;

  & .primaryFill {
    ${({ $primaryColor }) => $primaryColor && `fill: ${$primaryColor}`};
  }

  & .primaryStroke {
    ${({ $primaryColor }) => $primaryColor && `stroke: ${$primaryColor}`};
  }

  & .secondaryFill {
    ${({ $secondaryColor }) => $secondaryColor && `fill: ${$secondaryColor}`};
  }

  & .secondaryStroke {
    ${({ $secondaryColor }) => $secondaryColor && `stroke: ${$secondaryColor}`};
  }

  & svg {
    ${({ $width }) => $width && `width: ${$width}px;`}
    ${({ $height }) => $height && `height: ${$height}px;`}
  }
`

const SvgIconSc = styled(SvgIcon)``

export default SvgIconSc
